/**
 * Map of problem slugs to their interviewing.io-specific slug overrides.
 */
const INTERVIEWINGIO_SLUG_OVERRIDES: Record<string, string> = {
  '3-sum': 'three-sum',
  '2-sum': 'two-sum',
  '2-array-2-sum': 'two-array-two-sum',
  '4-directional-max-sum-path': 'four-directional-max-sum-path',
  '4-directional-max-sum-path-reconstruction':
    'four-directional-max-sum-path-reconstruction',
  'count-0-sum-paths': 'count-zero-sum-paths',
  'diameter-of-binary-tree': 'tree-diameter',
  'sliding-window-maximum': 'sliding-window-max',
}

export function getInterviewingioUrl(slug: string): string {
  const resolvedSlug = INTERVIEWINGIO_SLUG_OVERRIDES[slug] ?? slug
  return `https://start.interviewing.io/interview-ai?problemId=${resolvedSlug}`
}
